import React from 'react';
import MainBody from '../templates/MainBody';
import { finintContent } from '../data';

//financial intelligence gathering techniques and tools, companies house 

const FININT: React.FC = () => {
  return <MainBody data={finintContent} />;
};

export default FININT;